// extracted by mini-css-extract-plugin
export var actions = "_2n-0";
export var actionsContainer = "_2n-7";
export var border = "_2n-1";
export var childFullHeight = "_2n-f";
export var collapse = "_2n-2";
export var content = "_2n-a";
export var contentChild = "_2n-e";
export var fullscreen = "_2n-c";
export var hasLeftRadius = "_2n-k";
export var headerContainer = "_2n-3";
export var headerRow = "_2n-5";
export var hidePadding = "_2n-b";
export var navCollapsedGap = "_2n-l";
export var noScrollX = "_2n-m";
export var noScrollY = "_2n-n";
export var noTopPadding = "_2n-i";
export var optOutTopPadding = "_2n-d";
export var pageMain = "_2n-j";
export var pageOuter = "_2n-g";
export var pagePadding = "_2n-8";
export var pageScroll = "_2n-9";
export var profile = "_2n-o";
export var profileContainer = "_2n-p";
export var profileImage = "_2n-q";
export var profileMain = "_2n-r";
export var profileSubtitle = "_2n-t";
export var profileTitle = "_2n-s";
export var showLeftPadding = "_2n-h";
export var tabsPortalSlot = "_2n-6";
export var tabsWrapper = "_2n-4";
export var title = "_2n-u";